/**
 * Constellation avis — feuilles qui tombent en désordre puis se posent (une à une).
 */
(function () {
  'use strict';

  var ROTATIONS = [-2.8, 1.7, -1.5, 2.3, -0.8, 1.9, -2.1, 0.6, 1.4, -1.9, 2.05, -0.45, 1.1, -2.4, 0.9];
  var BASE_DELAY = 95;
  var JITTER = 55;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function shuffleDelays(count) {
    var order = [];
    var i;
    for (i = 0; i < count; i += 1) {
      order.push(i);
    }
    for (i = order.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = order[i];
      order[i] = order[j];
      order[j] = tmp;
    }
    var delays = [];
    order.forEach(function (rank, idx) {
      delays[rank] = idx * BASE_DELAY + Math.floor(Math.random() * JITTER);
    });
    return delays;
  }

  function landCard(card, delay) {
    window.setTimeout(function () {
      card.classList.add('is-landed');
    }, delay);
  }

  function init(container) {
    if (!container) return;

    var cards = container.querySelectorAll('.canicule-reviews__card');
    if (!cards.length) return;

    cards.forEach(function (card, index) {
      card.classList.remove('is-landed');
      card.style.setProperty('--canicule-drop-rotate', ROTATIONS[index % ROTATIONS.length] + 'deg');
    });

    if (prefersReducedMotion() || isMobileViewport()) {
      cards.forEach(function (card) {
        card.classList.add('is-landed');
      });
      return;
    }

    var delays = shuffleDelays(cards.length);
    var started = false;

    function play() {
      if (started) return;
      started = true;
      cards.forEach(function (card, index) {
        landCard(card, delays[index]);
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            play();
            obs.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
      );
      observer.observe(container);
    } else {
      play();
    }
  }

  window.CaniculeReviewsConstellation = { init: init };
})();
